import $ from 'jquery'
import { merge } from 'lodash'

let style = `
  <style>
    .wait__onion {
      display: none;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1040;
      background-color: rgba(0, 0, 0, 0.40);
    }

    .wait__dialog {
      opacity: 0.95;
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      left: 15px;
      bottom: -200px;
      width: 300px;
      min-height: 60px;
      background-color: #f1f3f8;
      border: 2px solid #ccc;
      border-radius: 16px;
      color: #111;
      z-index: 100000001;
      transition: bottom 0.3s;
      -webkit-transition: bottom 0.3s;
      -webkit-box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
      -moz-box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
      box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
    }

    .wait__badge {
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .wait__badge .fa {
      font-size: 32px;
      align-self: center;
    }

    .wait__content {
      padding: 12px 15px;
    }

    .wait__body {
      font-size: 16px;
      line-height: 20px;
      font-weight: bold;
      align-self: center;
    }

    .wait__dialog.show {
      bottom: 15px;
    }

    .wait__content {
      display: flex;
    }
  </style>
`

let onion = `
  <div class="wait__onion"></div>
`

let dialog = `
  <div class="wait__dialog">
    <div class="wait__content">
      <div class="wait__badge">
        
      </div>
      <div class="wait__body">
        Loading...
      </div>
    </div>
  </div>
`

let init = false
let $style = $(style)
let $dialog = $(dialog)
let $onion = null
let $badge = $dialog.find('.wait__badge')
let $body = $dialog.find('.wait__body')

let $icons = {
  wait: $('<i class="fa fa-circle-o-notch fa-spin"></i>'),
  ok: $('<i class="fa fa-thumbs-up"></i>'),
  error: $('<i class="fa fa-exclamation-triangle"></i>')
}

let timeouts = {}

let next = (callback, timeout) => {
  clearTimeout(timeouts.next)
  timeouts.next = setTimeout(() => {
    callback()
  }, timeout === undefined ? 3000 : timeout)
}

let wait = (message, icon) => {
  let config = {}

  if ($.isPlainObject(message)) {
    config = message
  } else {
    config = {
      message,
      icon
    }
  }

  if (!init) {
    $onion = $(onion)
    $('body').append($style)
    $('body').append($onion)
    $('body').append($dialog)
    init = true
  }

  if ((config.message === false) || config.hide) {
    // hide the onion immediately
    $onion.hide()
    // which icon are we displaying?
    let icon = $icons.ok
    if (config.icon) {
      if ($icons[config.icon]) {
        icon = $icons[config.icon]
      } else {
        icon = $(`<i class="${config.icon}"></i>`)
      }
    }
    $badge.html(icon)
    // message or default, "Done!"
    $body.html(config.message || '<span>Done!</span>')
    next(() => {
      $dialog.removeClass('show')
    })
  } else {
    next(() => {
      $dialog.addClass('show')
      $badge.html($icons.wait)
      $body.html(config.message || '<span>Loading...</span>')
    }, 0)

    if (config.onion) {
      $onion.show()
    }
  }
}

wait.loading = () => {
  wait({ message: 'Loading...' })
}

wait.loaded = () => {
  wait({ hide: true, message: 'Loaded!' })
}

wait.saving = (config) => {
  wait(merge({
    'message': 'Saving...',
    'icon': 'fa-save'
  }, config))
}

wait.saved = () => {
  wait({ hide: true, message: 'Saved!' })
}

wait.sending = () => {
  wait('Sending...', 'fa-paper-plane')
}

wait.sent = () => {
  wait({ hide: true, message: 'Sent!' })
}

wait.cancelling = (config) => {
  wait(merge({
    'message': 'Cancelling...',
    'icon': 'fa-times'
  }, config))
}

wait.cancelled = () => {
  wait({ hide: true, message: 'Cancelled!' })
}

wait.deleting = (config) => {
  wait(merge({
    'message': 'Deleting...',
    'icon': 'fa-trash'
  }, config))
}

wait.deleted = () => {
  wait({ hide: true, message: 'Deleted!' })
}

wait.uploaded = () => {
  wait({ hide: true, message: 'Uploaded!' })
}

wait.oops = () => {
  wait({
    hide: true,
    message: 'Oops! Something went wrong. Check it out.',
    icon: 'error'
  })
}

export default wait
